export default "__VITE_ASSET__CCdw_rsu__"